import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
    connect() {
        this.modal = new bootstrap.Modal(this.element, {
            keyboard: false
        })

        this.element.addEventListener("hidden.bs.modal", () => {
            this.clearTurboFrame()
            if (this.element.parentElement) {
                this.element.parentElement.innerHTML = ""
            }
            this.removeBackdrop();
        })

        // Clean up modal before navigating away
        this.beforeVisitHandler = () => {
            this.cleanup()
        }
        document.addEventListener("turbo:before-visit", this.beforeVisitHandler)

        // Clean up modal before page goes into cache
        this.beforeCacheHandler = () => {
            this.cleanup()
        }
        document.addEventListener("turbo:before-cache", this.beforeCacheHandler)

        this.modal.show()
    }

    disconnect() {
        this.cleanup()
        
        // Remove event listeners
        if (this.beforeVisitHandler) {
            document.removeEventListener("turbo:before-visit", this.beforeVisitHandler)
        }
        if (this.beforeCacheHandler) {
            document.removeEventListener("turbo:before-cache", this.beforeCacheHandler)
        }
    }

    cleanup() {
        if (this.modal) {
            this.modal.hide()
        }
        this.removeBackdrop()
        this.removeBodyClasses()
        this.clearTurboFrame()
    }

    removeBackdrop() {
        // Remove all modal backdrops
        document.querySelectorAll('.modal-backdrop').forEach(backdrop => {
            backdrop.remove()
        })
    }

    removeBodyClasses() {
        // Remove modal-related classes from body
        document.body.classList.remove('modal-open')
        document.body.style.overflow = ''
        document.body.style.paddingRight = ''
    }

    submitEnd(event) {
        if (event.detail.success) {
            this.modal.hide()
        }
    }

    closeWithKeyboard(event) {
        if (event.key === "Escape") {
            this.modal.hide()
        }
    }

    closeBackground(event) {
        if (event.target === this.element) {
            this.modal.hide()
        }
    }

    clearTurboFrame() {
        const turboFrame = this.element.closest("turbo-frame")
        if (turboFrame) {
            turboFrame.innerHTML = ''
        }
    }
}